var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mt-4 max-w-3xl mx-auto" }, [
    _c("div", { staticClass: "bg-white shadow sm:rounded-lg" }, [
      _c("div", { staticClass: "px-4 py-5 sm:p-6" }, [
        _c(
          "div",
          { staticClass: "sm:flex sm:items-start sm:justify-between" },
          [
            _vm._m(0),
            _c(
              "div",
              {
                staticClass:
                  "mt-5 sm:mt-0 sm:ml-6 sm:flex-shrink-0 sm:flex sm:items-center"
              },
              [
                _c(
                  "span",
                  { staticClass: "inline-flex rounded-md shadow-sm" },
                  [
                    _c(
                      "button",
                      {
                        staticClass:
                          "Polaris-Button Polaris-Button--primary animate-bounce",
                        attrs: { type: "button" },
                        on: { click: _vm.openReviewPage }
                      },
                      [_vm._m(1)]
                    )
                  ]
                )
              ]
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h3", { staticClass: "text-lg leading-6 font-medium text-gray-900" }, [
        _vm._v(" Enjoying our app? ❤️ ")
      ]),
      _c(
        "div",
        { staticClass: "mt-2 max-w-xl text-sm leading-5 text-gray-500" },
        [
          _c("p", [
            _vm._v(
              " I hope our app is useful to your store. We are working hard to build this app. Please give us your love by writing a review. Thank you from carthike team :) "
            ),
            _c("br")
          ])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "Polaris-Button__Content" }, [
      _c("span", { staticClass: "Polaris-Button__Text" }, [
        _vm._v("Write a review")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }